
import { onMounted, ref } from "vue";
import gsap from "gsap";

export default {
  name: "Landing",
  components:{
  },
  data() {
    return {
    };
  },
  setup() {
    let tl = gsap.timeline({ defaults: {ease: "power4.inOut", duration: 2}})
    onMounted(() => {
      gsap.fromTo(
    "#heading-1",
    { opacity: 0, y: "10%"},
    { duration: 3, opacity: 1, x: 0 }
  );

  tl.to("#svg",{
    // defaults: {ease:"power4.inOut", duration: 2},
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)", opacity: 1, y:0, duration: 3.2
  })
  .to('#title', {
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)", opacity: 1, y: 0 }, "-=2" )
    .to('#title-2', {
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)", opacity: 1, y: 0 }, "-=1" )
    .to('#description', {
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)", opacity: 1, y: 0 }, "-=0.5" )
    .to('#more', {
    clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)", opacity: 1, y: 0 }, "-=0.2" )
  }
)},

};
